import React from 'react';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import { Spinner, PageLoader } from '../components/common/Loader';
import NetworkGuard from '../components/common/NetworkGuard';
import RegisterForm from '../components/register/RegisterForm';
import { useNavigate } from 'react-router-dom';

export default function RegisterPage() {
  const { isConnected, connect, connecting } = useWallet();
  const { balances, refresh, isRegistered, loading } = useUserData();
  const navigate = useNavigate();

  if (!isConnected) {
    return (
      <div className="container register-page">
        <div className="empty-state">
          <div className="icon">🔒</div>
          <h3 style={{ marginBottom: 8 }}>Connect Your Wallet</h3>
          <p style={{ marginBottom: 24 }}>Connect a wallet to register your mining account.</p>
          <button className="btn btn-primary btn-lg" onClick={connect} disabled={connecting}>
            {connecting ? <><Spinner /> Connecting</> : 'Connect Wallet'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <NetworkGuard>
      <div className="container register-page">
        {loading ? (
          <PageLoader label="LOADING" sub="Preparing registration..." />
        ) : isRegistered ? (
          <div className="empty-state">
            <div className="icon">✓</div>
            <h3 style={{ marginBottom: 8 }}>Already Registered</h3>
            <p style={{ marginBottom: 24 }}>Your account is active. Head to the dashboard.</p>
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/dashboard')}>
              Go to Dashboard →
            </button>
          </div>
        ) : (
          <RegisterForm balances={balances} onDone={refresh} />
        )}
      </div>
    </NetworkGuard>
  );
}
